import { render, staticRenderFns } from "./GiftAddCheckbox.vue?vue&type=template&id=77198639&scoped=true&"
import script from "./GiftAddCheckbox.vue?vue&type=script&lang=ts&"
export * from "./GiftAddCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./GiftAddCheckbox.vue?vue&type=style&index=0&id=77198639&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77198639",
  null
  
)

export default component.exports